<template>
  <v-row>
    <input id="trackUrl" style="position: absolute; left: -1000px; top: -1000px" />

    <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn small color="blue" class="text-none" dark v-on="on">Message Customer</v-btn>
      </template>

      <v-list>
        <v-list-item @click="copyTrackLink" class="text-none" small color="white">Copy Track Link</v-list-item>
        <v-list-item
          @click="showSendTrackLinkDialog"
          class="text-none"
          small
          color="white"
        >Send Track Link (SMS)</v-list-item>
        <v-list-item
          @click="showSendSMSDialog"
          class="text-none"
          small
          color="white"
        >Send Message (SMS)</v-list-item>
      </v-list>
    </v-menu>

    <v-flex px-1>
      <v-btn
        submit
        class="text-none"
        small
        color="white"
        target="_blank"
        :href="'/book?rebook=' + bookingForm.booking.id"
      >Copy</v-btn>
    </v-flex>
    <v-dialog v-model="trackDialog" width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Send Track Link (SMS)</span>
        </v-card-title>
        <v-layout column px-4>
          <v-text-field v-model="smsContactNumber" label="Contact Number"></v-text-field>
          <p style="color:red;" v-if="smsError != null">{{ smsError }}</p>
        </v-layout>
        <v-card-actions v-if="loadingSendSMS == false">
          <v-spacer></v-spacer>
          <v-btn class="text-none" text @click="trackDialog = false">Cancel</v-btn>
          <v-btn class="text-none" text @click="sendTrackURLMessage()">Send Message</v-btn>
        </v-card-actions>
        <v-progress-linear v-if="loadingSendSMS == true" indeterminate color="yellow darken-2"></v-progress-linear>
      </v-card>
    </v-dialog>
    <v-dialog v-model="customSMSDialog" width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Send Custom SMS</span>
        </v-card-title>
        <v-layout column px-4>
          <v-textarea placeholder="Your custom message" v-model="customMessage"></v-textarea>
          <v-text-field v-model="smsContactNumber" label="Contact Number"></v-text-field>
          <p style="color:red;" v-if="smsError != null">{{ smsError }}</p>
        </v-layout>
        <v-card-actions v-if="loadingSendSMS == false">
          <v-spacer></v-spacer>
          <v-btn class="text-none" text @click="customSMSDialog = false">Cancel</v-btn>
          <v-btn class="text-none" text @click="sendCustomSMS()">Send Message</v-btn>
        </v-card-actions>
        <v-progress-linear v-if="loadingSendSMS == true" indeterminate color="yellow darken-2"></v-progress-linear>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SimpleTextAreaInput from "@/components/widget/input/SimpleTextAreaInput.vue";

import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "BookingActions",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    SimpleTextAreaInput,
    BookTripETARoute
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    updateMode: {
      type: Boolean,
      default: false
    },
    largeMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menu: false,
      cancelDialog: false,
      trackDialog: false,
      customSMSDialog: false,
      loadingSendSMS: false,
      smsError: null,
      smsContactNumber: null,
      customMessage: ""
    };
  },
  methods: {
    copyTrackLink: function() {
      const el = document.getElementById("trackUrl");
      el.value = this.bookingForm.booking.track_booking_url;
      el.select();
      document.execCommand("copy");

      console.log("Copied " + el.value);
    },
    showSendTrackLinkDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_number != null) {
        this.smsContactNumber = this.bookingForm.booking.business_customer_number;
      } else {
        this.smsContactNumber = this.bookingForm.user.contact_number;
      }

      this.trackDialog = true;
    },
    showSendSMSDialog: function() {
      this.smsError = null;

      if (this.bookingForm.booking.business_customer_number != null) {
        this.smsContactNumber = this.bookingForm.booking.business_customer_number;
      } else {
        this.smsContactNumber = this.bookingForm.user.contact_number;
      }

      this.customSMSDialog = true;
    },
    sendTrackURLMessage: async function() {
      console.log("Sending Track URL");

      this.smsError = null;

      if (this.smsContactNumber == null || this.smsContactNumber.length <= 0) {
        this.smsError =
          "Please enter a contact number for the messages recipient";
        return;
      }

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/sendTrackURLMessage?booking_id=${
            this.bookingForm.booking.id
          }&contact_number=${this.smsContactNumber.trim()}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        if (response.data.error == "no_error") {
          this.trackDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    },
    sendCustomSMS: async function() {
      console.log("Sending Track URL");

      this.smsError = null;

      if (this.smsContactNumber == null || this.smsContactNumber.length <= 0) {
        this.smsError =
          "Please enter a contact number for the messages recipient";
        return;
      }

      this.loadingSendSMS = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/booking/customMessage?message=${
            this.customMessage
          }&contact_number=${this.smsContactNumber.trim()}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loadingSendSMS = false;

        console.log(response.data.error);

        if (response.data.error == "no_error") {
          this.customSMSDialog = false;
        } else {
          this.smsError = response.data.error;
        }
      } catch (error) {
        console.log(error);
        this.smsError = "Unknown Error";

        this.loadingSendSMS = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
